var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessegeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.854799 10.2586L3.65171 13.0555L3.65381 16.7521C3.65326 16.9515 3.69212 17.1489 3.76815 17.3332C3.84418 17.5175 3.95589 17.6849 4.09684 17.8258C4.18972 17.9184 4.29389 17.9989 4.40691 18.0655C4.63413 18.2011 4.8931 18.2745 5.15771 18.2782C5.42232 18.2818 5.68322 18.2157 5.91415 18.0865L20.2697 10.2549L0.854799 10.2586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.836914 8.76922L20.2676 8.76764L5.91256 0.951325C5.68072 0.822154 5.41914 0.755843 5.15377 0.758971C4.88839 0.762099 4.62845 0.834558 4.39972 0.969159C4.171 1.10376 3.98144 1.29582 3.84986 1.5263C3.71827 1.75677 3.64923 2.01765 3.64959 2.28304L3.65117 5.95497L0.836914 8.76922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessegeImg);
export default __webpack_public_path__ + "static/media/send-messege-img.891b277a5c6225aa35a88ef1b953efbe.svg";
export { ForwardRef as ReactComponent };